import axios from 'axios';
import { notify } from '../helpers';
import { Config } from '../Config';
import { userAccessToken } from '../helpers'; // adjust path if needed

export const handleFileUpload = async (e, data, setLoading) => {
  e.preventDefault();
  setLoading(true);

  const {
    practice_name,
    location_name,
    emr,
    patient_file,
    icd_file,
    cpt_file
  } = data;

  if (
    !practice_name ||
    // !location_name ||
    !emr ||
    !patient_file ||
    !icd_file ||
    !cpt_file
  ) {
    notify('error', 'All fields and files are required.');
    setLoading(false);
    return;
  }

  const formData = new FormData();
  formData.append('practice_name', practice_name);
  formData.append('location_name', location_name);
  formData.append('emr', emr);
  formData.append('patient_file', patient_file);
  formData.append('icd_file', icd_file);
  formData.append('cpt_file', cpt_file);

  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/onboard-file-upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${userAccessToken()}`,
          AccessKey: '96d988dbd22dc912efa0be577615aabe5c4782d896d988dbd22dc912efa0be577615aabe5c4782d8'
        },
      }
    );

    notify('success', 'Files uploaded and stored to S3 successfully.');
    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      'Upload failed. Please try again.';
    notify('error', errorMessage);
    return error?.response?.data;
  } finally {
    setLoading(false);
  }
};
